import { Component, inject, OnInit } from '@angular/core';
import { CHECKOUT_SUMMARY_SNAPSHOT, config, LoggingService, OrderRequest, PaymentService } from '@fgb/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'fgb-portal-product-results-page',
  templateUrl: './portal-product-results-page.component.html',
  styleUrls: ['./portal-product-results-page.component.scss'],
})
export class PortalProductResultsPageComponent implements OnInit {
  private checkoutSnapshot = inject(CHECKOUT_SUMMARY_SNAPSHOT);
  private paymentService = inject(PaymentService);

  constructor(
    // private purchaseService: PurchaseService,
    private route: ActivatedRoute,
    private logService: LoggingService,
    public router: Router
  ) {}

  ngOnInit() {
    let orderId: string | null = null;
    const purchaseOrderId = this.route.snapshot.queryParamMap.get('purchaseOrderId') || undefined;

    if (this.route.snapshot.queryParamMap.keys.map((x) => x.toUpperCase()).includes('ORDERID')) {
      const orderIdQueryStringKey = this.route.snapshot.queryParamMap.keys.filter((x) => x.toUpperCase() === 'ORDERID')[0];
      orderId = this.route.snapshot.queryParamMap.get(orderIdQueryStringKey);
    }
    if (!(orderId || purchaseOrderId)) {
      this.logService.error('No order ID could be found in the query string');
      return;
    }

    const callbackUrl = config.baseApiUrl + this.router.url;
    const { successUrl, failureUrl } = this.getNavigationUrl(this.checkoutSnapshot);

    // Only includes `orderId` or `purchaseOrderId` if their values are not null or undefined
    const params = {
      orderId,
      purchaseOrderId,
    };

    this.paymentService.completePayment(params, callbackUrl, successUrl, failureUrl);

    // @TODO do something with purchase service
    // this.purchaseService.checkOrderSuccessStatus(orderId, '/portalproducts/success', '/portalproducts/failure');
  }

  private getNavigationUrl(checkout: OrderRequest | null): { successUrl: string; failureUrl: string } {
    return {
      successUrl: checkout?.successUrl || '/portalproducts/success',
      failureUrl: checkout?.failureUrl || '/portalproducts/failure',
    };
  }
}
